const language = {
  EN: 'EN',
  HU: 'HU'
}

export default language
